import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoalOverviewComponent } from './goal-overview.component';
import { SharedDirectivesModule } from '@EYN/lib';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [GoalOverviewComponent],
	exports: [GoalOverviewComponent],
	imports: [
		CommonModule,
		SharedDirectivesModule,
		RouterModule.forChild([]),
	]
})
export class GoalOverviewModule {
}
